import React from 'react';
import { Link } from 'react-router-dom';

import Toggle from 'components/partials/toggle/toggle';

const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-8';

export const getRelatedGoalsTableSettings = (
  linkedGoals,
  handleToggleChange,
  isToggling,
  clientId
) => [
  {
    header: () => <span>GOAL CATEGORY</span>,
    accessorKey: 'category',
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'pl-4 py-3 tablet:w-[30%] font-semibold',
    enableSorting: false,
  },
  {
    header: () => <span>GOAL DESCRIPTION</span>,
    accessorKey: 'description',
    headerClassName: commonStyles,
    className: 'pl-4 py-3 tablet:w-[50%]',
    enableSorting: false,
    cell: ({ row }) => {
      const goal = row.original;
      const goalText = goal.description || goal.summary || goal.category;

      const goalLink = `/admin/clients/${clientId}/goals/${
        goal.enteringClassYear
      }/${goal.type?.toLowerCase()}/${goal.category?.toLowerCase()}/${goal.id}`;

      return (
        <Link to={goalLink} className="text-blue-02 underline">
          {goalText}
        </Link>
      );
    },
  },
  {
    header: () => <span>LINK</span>,
    id: 'link',
    headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
    className: 'pl-4 py-3 tablet:w-[20%]',
    isHeaderCentered: true,
    enableSorting: false,
    cell: ({ row }) => {
      const goal = row.original;

      const isArrayOfIds =
        Array.isArray(linkedGoals) &&
        linkedGoals.length > 0 &&
        typeof linkedGoals[0] !== 'object';

      const isLinked = isArrayOfIds
        ? linkedGoals.includes(goal.id)
        : linkedGoals.some((g) => g.id === goal.id);

      return (
        <div className="flex justify-center">
          <Toggle
            isToggleOn={isLinked}
            onToggleChange={(newValue) => handleToggleChange(goal, newValue)}
            disabled={isToggling}
          />
        </div>
      );
    },
  },
];
